var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_47462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0506 18.0253C21.2544 18.0253 17.3671 21.9126 17.3671 26.7088C17.3671 31.5051 21.2544 35.3924 26.0506 35.3924C30.8468 35.3924 34.7342 31.5051 34.7342 26.7088C34.7342 21.9126 30.8468 18.0253 26.0506 18.0253ZM31.3809 26.292L27.4689 30.0752C26.8148 30.7206 25.9464 31.0463 25.0766 31.0463C24.2068 31.0463 23.3356 30.7206 22.6698 30.0708L20.7103 28.1431C20.1386 27.583 20.1314 26.6669 20.69 26.0966C21.2486 25.525 22.1647 25.5163 22.7364 26.0764L24.6946 28.0027C24.903 28.2082 25.2445 28.2039 25.45 27.9998L29.3764 24.2022C29.951 23.6508 30.8686 23.6667 31.4229 24.2442C31.9757 24.8202 31.9569 25.7377 31.3809 26.292ZM18.4019 35.3924H8.68355C4.68911 35.388 1.4516 32.1505 1.44726 28.1561V16.578C1.44726 15.7792 2.09563 15.1308 2.89452 15.1308H26.0434C19.6624 15.1351 14.4726 20.3264 14.4726 26.7088C14.4726 30.1634 15.9936 33.2693 18.4019 35.3924ZM4.34177 12.2363C1.94511 12.2363 0 10.2926 0 7.89449C0 3.89717 3.23896 0.658203 7.23629 0.658203C7.23629 0.658203 27.7077 0.661098 27.8134 0.665439C31.8107 0.83911 34.9093 4.2199 34.7342 8.21723C34.5866 10.4967 32.6791 12.2638 30.3924 12.2363H4.34177Z",
    fill: "#5FBB40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_47462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7342,
    height: 34.7342,
    fill: "white",
    transform: "translate(0 0.658203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverIcon);
export default __webpack_public_path__ + "static/media/deliver-icon.6be8c2c51b971d2086886b811cfa86a3.svg";
export { ForwardRef as ReactComponent };